export default __webpack_public_path__ + "static/media/about.edbb730d.png";